<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">Dropdown definitions</h1>
    <div class="mb-2">
      <b-button :variant="isDarkMode ? 'primary' : 'success'" size="sm" @click="onNew">
        <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" /> New dropdown
      </b-button>
    </div>
    <div
      :class="{
        'box-shadow2': !isDarkMode,
        '': isDarkMode
      }"
    >
      <div
        :class="{
          'table-row table-row-header': !isDarkMode,
          'table-row-dark v-step-1 dark-div border-top': isDarkMode
        }"
      >
        <div
          v-for="(column, index) in columns"
          :key="'h-' + column.headerText + index"
          :class="{
            ...column.class,
            'table-column': !isDarkMode,
            'table-column-dark': isDarkMode,
            'table-column-first': index === 0,
            'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1
          }"
          :style="{ width: column.width }"
        >
          {{ column.headerText }}
        </div>
      </div>
      <div
        v-for="row in tableRows"
        :key="row.key"
        :class="{
          'table-row ': !isDarkMode,
          'table-row-dark': isDarkMode
        }"
      >
        <div
          v-for="(column, index) in columns"
          :key="column.headerText + row.key + index"
          :class="{
            ...column.class,
            'table-column ': !isDarkMode,
            'table-column-dark': isDarkMode,
            'table-column-first': index === 0,
            'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1
          }"
          :style="{ width: column.width }"
        >
          <span v-if="column.textKey" class="span-text">{{ row[column.textKey] }}</span>
          <div v-if="column.type === 'functions'" class="text-center">
            <b-button-group size="sm">
              <b-button
                size="sm"
                :variant="isDarkMode ? 'outline-light' : 'secondary'"
                class="box-shadow2"
                @click="onEdit(row)"
              >
                <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" />Edit
              </b-button>
              <b-button size="sm" :variant="isDarkMode ? 'outline-warning' : 'warning'" @click="onDelete(row)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" class="mr-1" />Delete
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>
      <div
        v-if="!loading && (!tableRows || tableRows.length === 0)"
        :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
      >
        <div
          :class="{
            'table-column table-column-full text-center': !isDarkMode,
            'table-column-dark table-column-full text-center': isDarkMode
          }"
        >
          No dropdowns found.
        </div>
      </div>
      <b-overlay v-if="loading" show :variant="isDarkMode ? 'outline-light' : 'outline-secondary'">
        <div :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }">
          <div
            :class="{
              'table-column table-column-full text-center': !isDarkMode,
              'table-column-dark table-column-full text-center': isDarkMode
            }"
          />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Vue from 'vue';

export default {
  name: 'DropdownList',
  metaInfo() {
    return {
      title: 'Dropdown admin'
    };
  },
  data() {
    return {
      columns: [
        {
          type: 'string',
          headerText: 'Key',
          class: { 'text-center': true },
          textKey: 'key',
          width: '20%'
        },
        {
          type: 'string',
          headerText: 'Active',
          class: { 'text-center': true },
          textKey: 'activeLabel',
          width: '20%'
        },
        {
          type: 'string',
          headerText: 'Categories',
          class: { 'text-center': true },
          textKey: 'categoryCount',
          width: '20%'
        },
        {
          type: 'string',
          headerText: 'Updated',
          class: { 'text-center': true },
          textKey: 'updatedAt',
          width: '20%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '20%'
        }
      ]
    };
  },
  mounted() {
    this.list({ router: this.$router });
  },
  computed: {
    ...mapState('dropdownAdmin', ['loading']),
    ...mapState('darkMode', ['isDarkMode']),
    tableRows() {
      const raw = this.$store.state.dropdownAdmin.list;
      return (raw || []).map(d => ({
        key: d.key,
        activeLabel: d.isActive ? 'Yes' : 'No',
        categoryCount: Array.isArray(d.categories) ? d.categories.length : 0,
        updatedAt: d.updatedAt ? String(d.updatedAt).slice(0, 19).replace('T', ' ') : '',
        raw: d
      }));
    }
  },
  methods: {
    ...mapActions('dropdownAdmin', ['list', 'deleteOne']),
    onNew() {
      this.$router.push('/dropdowns-admin/new');
    },
    onEdit(row) {
      this.$router.push({
        path: `/dropdowns-admin/${encodeURIComponent(row.key)}`
      });
    },
    onDelete(row) {
      Vue.swal({
        title: 'Delete this dropdown?',
        text: row.key,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: () => {
          this.deleteOne({ key: row.key, router: this.$router });
        }
      });
    }
  }
};
</script>
